import React, { useState, useEffect } from "react";
import {
  RootContainer,
  Heading,
  NavContainer,
  ArrowIconWrapper,
  SkipButton,
  Logo,
  Title,
  ContentContainer,
  Form,
  Input,
  ContinueButton,
  GoToLoginBtn,
  ORTextForRegister,
  Divider,
} from '../AuthStack.style';
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import { openAlert } from "@redux/app/appSlice";
import { Alert } from "@components";
import { useTranslation } from "react-i18next";
import ConfirmModal from "./ConfirmModal/ConfirmModal";
import { SERVER_ERROR_CODES } from '@constants';
import { AuthBackIcon } from '@assets';
import { Space } from "antd";

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const REFERRAL_ID_KEY = "referral_id";

const PromoRegister = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  const [name, setName] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [promocode, setPromocode] = useState();

  // inactive promocode
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  // Disable Continue button when name or phoneNumber is empty
  useEffect(() => {
    setDisableButton(!(name && phoneNumber && promocode));
  }, [name, phoneNumber, promocode]);

  const onFinish = (data) => {
    if (!loading) {
      setLoading(true);
      api
        .preRegister({
          phone: data.phone,
          promocode,
        })
        .then(() => {
          setLoading(false);
          successCallback(data);
        })
        .catch((error) => {
          setLoading(false);
          if (error.statusCode === SERVER_ERROR_CODES.INACTIVE_PROMOCODE) {
            setOpen(true);
            setMessage(error.message);
          }
          else {
            showAlert({
              message: error,
              isError: true,
            });
          }
        });
    }
  };

  const successCallback = (data) => {
    let referral_id = query.get(REFERRAL_ID_KEY);
    if (referral_id) {
      data.referral_id = referral_id;
    }
    navigate(`/${PUBLIC_ROUTE.CREATE_PASSWORD}`, {
      state: data,
    });
  };

  const skip = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const onOk = () => {
    navigate(`/${PUBLIC_ROUTE.REGISTER}`);
  }

  const onCancel = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goToLogin = () => {
    navigate(`/${PUBLIC_ROUTE.LOGIN}`)
  }

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.REGISTER}`);
  };

  if (isLoggedIn) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
  }

  return (
    <>
      <RootContainer>
        <Heading>
          <NavContainer>
            <ArrowIconWrapper onClick={goBack}>
              <AuthBackIcon />
            </ArrowIconWrapper>
            <SkipButton type="secondary" onClick={skip} > {t("common.skip")} </SkipButton>
          </NavContainer>
          <Logo />
        </Heading>

        <ContentContainer>
          <Title> {t("auth.register")} </Title>
          <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
            <Form.Item
              name="name"
              label={t("auth.registerName")}
              rules={[
                {
                  required: true,
                  message: "",
                },
                {
                  min: 4,
                  max: 45,
                  message: t("auth.registerNameValidate"),
                },
              ]}
            >
              <Input
                autoFocus
                size="large"
                placeholder={t("auth.registerNamePlaceholder")}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              name="phone"
              label={t("auth.registerPhone")}
              rules={[
                {
                  required: true,
                  message: "",
                },
                {
                  pattern: /^0(1|9)\d{7,9}$/,
                  message: t("auth.registerPhoneValidate"),
                },
              ]}
            >
              <Input
                type="number"
                size="large"
                placeholder={t("auth.enterPhone")}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              name="promocode"
              label={t("auth.registerPromocode")}
              rules={[
                {
                  required: true,
                  message: "",
                },
                {
                  //   pattern: /^0(1|9)\d{7,9}$/,
                  message: t("auth.registerPromocodeValidate"),
                },
              ]}
            >
              <Input
                type="text"
                size="large"
                placeholder={t("auth.enterPromocode")}
                onChange={(e) => setPromocode(e.target.value)}
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0}}>
              <ContinueButton
                type="primary"
                size="large"
                htmlType="submit"
                disabled={disableButton}
                loading={loading}
              >
                {t("common.continue")}
              </ContinueButton>
            </Form.Item>
          </Form>
        </ContentContainer>

        <Space>
          <Divider />
          <ORTextForRegister> {t("auth.or")} </ORTextForRegister>
          <Divider />
        </Space>

        <GoToLoginBtn
          onClick={goToLogin}
          type="secondary"
        >
          {t("auth.login")}
        </GoToLoginBtn>

      </RootContainer>
      <Alert />
      <ConfirmModal
        open={open}
        message={message}
        onOk={onOk}
        onCancel={onCancel}
      />
    </>
  );
};

export default PromoRegister;
